import BaseProxy from './Base';

class TeamsProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('teams', parameters, 'api/v1');
  }

  getTeams(query) {
    const parameters = {};
    if (!Object.prototype.hasOwnProperty.call(query, 'page')) {
      parameters.page = 1;
    } else {
      parameters.page = query.page;
    }
    if (!Object.prototype.hasOwnProperty.call(query, 'limit')) {
      parameters.limit = 30;
    } else {
      parameters.limit = query.limit;
    }
    if (Object.prototype.hasOwnProperty.call(query, 'column')) {
      parameters.order = `${query.order === 'descending' ? '-' : ''}${query.column}`;
    } else {
      parameters.order = 'name';
    }
    if (Object.prototype.hasOwnProperty.call(query, 'filter')) {
      parameters.q = query.filter;
    }
    this.setParameters(parameters);
    return this.load();
  }

  search(keyword) {
    this.setParameter('q', keyword);
    return this.load();
  }

  delete(itemsIds) {
    const ids = Array.isArray(itemsIds) ? itemsIds : [itemsIds];
    return this.submit('delete', `/${this.endpoint}`, { teams_ids: ids });
  }
}

export default TeamsProxy;
